import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/base/SeoHead';

const FORM_URL = 'https://readdy.ai/api/form/d9qasr7nahb7382ov8ug';

const testimonials = [
  {
    name: '小婷',
    marriage: '结婚 8 个月',
    content: '作为第一次的人妻，真的有很多迷茫的地方。这个网站就像是我的婚姻指南，每次遇到问题都会在这里找到答案。特别是夫妻沟通的文章，让我和老公的关系变得更加亲密。',
  },
  {
    name: '雅琳',
    marriage: '结婚 1 年 3 个月',
    content: '婆媳相处的文章救了我！之前总是不知道该怎么和婆婆相处，看了那些文章后，学会了建立边界又不失尊重的方法。现在家里氛围好多了。',
  },
  {
    name: '思涵',
    marriage: '结婚 6 个月',
    content: '最推荐角色适应和自我成长这两个分类。结婚后一度迷失了自己，是这些文章提醒我，成为妻子不意味着放弃自己。现在我在婚姻中反而变得更加独立和自信。',
  },
  {
    name: '婉清',
    marriage: '结婚 2 年',
    content: '从新婚到现在已经两年了，这个网站陪伴我走过了最迷茫的时期。每一篇文章都像是在和一个理解你的朋友聊天，温暖又有力量。强烈推荐给每一位新婚妻子。',
  },
];

export default function AboutPage() {
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="contact_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      setFormState({ name: '', email: '', message: '' });
      return;
    }

    if (!formState.name.trim() || !formState.email.trim() || !formState.message.trim()) return;
    if (formState.message.length > 500) {
      setFormError('留言内容不能超过500个字符');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormState({ name: '', email: '', message: '' });
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormError('提交失败，请稍后再试');
        } else {
          setFormStatus('error');
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请稍后再试');
    }
  };

  return (
    <>
      <SeoHead
        title="关于我们——第一次的人妻 | 品牌介绍"
        description="第一次的人妻致力于为初为人妻的女性提供角色适应、家庭经营、夫妻沟通与自我成长的实用指南。了解我们的品牌故事与使命。"
        keywords="第一次的人妻,关于我们,婚姻指南品牌,新婚女性社区,婚姻经营平台"
        canonicalUrl="/about"
      />
      <Navbar />
      <main className="min-h-screen pt-20">
        <nav className="w-full max-w-7xl mx-auto px-4 md:px-6 pt-8">
          <div className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">关于我们</span>
          </div>
        </nav>

        <section className="w-full py-12 md:py-16">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="text-2xl md:text-4xl font-heading text-foreground-900 text-center mb-6">关于第一次的人妻</h1>
            <p className="text-foreground-600 text-sm md:text-base text-center max-w-2xl mx-auto leading-relaxed">
              我们是一个专为初为人妻的女性打造的婚姻经营与自我成长平台，陪伴每一位新婚妻子从容度过角色转变的关键期。
            </p>
          </div>
        </section>

        <section className="w-full py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8">品牌故事</h2>
            <div className="space-y-5">
              <div className="bg-white rounded-xl p-6 border border-background-200">
                <h3 className="font-heading text-lg text-foreground-900 mb-3">我们的起点</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  "第一次的人妻"诞生于一个简单的想法：每一位新婚妻子都值得被温柔指导。创始人晓薇在结婚后的第一年里，深刻体会到了从"女友"到"妻子"这个角色转变带来的种种挑战——家务分工、婆媳相处、夫妻沟通、自我定位……她发现市面上缺少一个系统化的平台，能够真正理解并帮助第一次成为妻子的女性。
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 border border-background-200">
                <h3 className="font-heading text-lg text-foreground-900 mb-3">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们相信，婚姻不是女性自我的终结，而是一段全新成长的开始。通过提供专业、温暖、实用的内容，我们帮助每一位第一次的人妻在角色适应中找到节奏，在家庭经营中找到方法，在夫妻沟通中找到默契，在自我成长中找到方向。
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 border border-background-200">
                <h3 className="font-heading text-lg text-foreground-900 mb-3">我们的价值观</h3>
                <ul className="space-y-3 text-sm text-foreground-600">
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 rounded-full bg-primary-400 mt-2 flex-shrink-0"></span>
                    <span><strong className="text-foreground-800">真实</strong>——每一篇文章都来自真实的婚姻体验和专业的心理学知识，不贩卖焦虑，只提供切实可行的解决方案。</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 rounded-full bg-accent-400 mt-2 flex-shrink-0"></span>
                    <span><strong className="text-foreground-800">温暖</strong>——我们理解每一位新婚妻子的迷茫与不安，用温柔的文字陪伴你走过每一个困惑的时刻。</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 rounded-full bg-secondary-400 mt-2 flex-shrink-0"></span>
                    <span><strong className="text-foreground-800">成长</strong>——婚姻是一次成长的机会，我们鼓励每一位女性在婚姻中保持独立、持续学习、活出更精彩的自己。</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-16">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8 text-center">读者口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200">
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">"{t.content}"</p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-medium text-primary-600">{t.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.marriage}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-3 text-center">联系我们</h2>
            <p className="text-sm text-foreground-600 text-center mb-8">
              如果你有任何问题、建议或合作意向，欢迎通过下方表单联系我们。
            </p>

            {formStatus === 'success' ? (
              <div className="text-center py-10">
                <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-check-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-xl text-foreground-900 mb-2">消息已发送！</h3>
                <p className="text-sm text-foreground-600">感谢你的留言，我们会尽快回复你。</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="space-y-5">
                <div>
                  <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-2">姓名</label>
                  <input
                    id="about-name"
                    type="text"
                    name="name"
                    value={formState.name}
                    onChange={(e) => setFormState((s) => ({ ...s, name: e.target.value }))}
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入你的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-2">邮箱</label>
                  <input
                    id="about-email"
                    type="email"
                    name="email"
                    value={formState.email}
                    onChange={(e) => setFormState((s) => ({ ...s, email: e.target.value }))}
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入你的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-2">
                    留言 <span className="text-foreground-400 font-normal">（不超过500字）</span>
                  </label>
                  <textarea
                    id="about-message"
                    name="message"
                    value={formState.message}
                    onChange={(e) => setFormState((s) => ({ ...s, message: e.target.value }))}
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 rounded-lg bg-white border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请写下你想说的话..."
                  />
                  <p className="text-xs text-foreground-400 mt-1 text-right">{formState.message.length}/500</p>
                </div>

                <input
                  type="text"
                  name="contact_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="anti-spam-field"
                />

                {formStatus === 'error' && (
                  <p className="text-sm text-red-500">{formError}</p>
                )}

                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 disabled:opacity-60 whitespace-nowrap"
                >
                  {formStatus === 'loading' ? '发送中...' : '发送留言'}
                </button>
              </form>
            )}
          </div>
        </section>

        <section className="w-full py-12 md:py-16">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8">常见问题</h2>
            <div className="space-y-4">
              {[
                { q: '这个网站的内容是免费的吗？', a: '是的，所有文章和指南内容完全免费。我们希望通过免费的方式帮助更多新婚女性。订阅邮件也是免费的。' },
                { q: '文章的作者是谁？', a: '我们的文章由多位经历过婚姻磨合期的女性共同创作，同时也有持证心理咨询师对内容进行专业把关。' },
                { q: '如何订阅每周婚姻指南？', a: '在首页底部输入你的邮箱地址即可免费订阅。每周五我们会准时推送一篇精心准备的婚姻经营内容到你的邮箱。' },
                { q: '可以投稿分享自己的故事吗？', a: '当然可以！我们非常欢迎读者分享自己的婚姻故事和经验。请通过"联系我们"表单与我们取得联系。' },
              ].map((item, i) => (
                <details key={i} className="bg-background-100 rounded-xl border border-background-200 overflow-hidden group">
                  <summary className="p-5 cursor-pointer flex items-center justify-between text-sm md:text-base font-medium text-foreground-800 hover:text-primary-600 transition-colors">
                    {item.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们——第一次的人妻',
            description: '为初为人妻的女性提供角色适应、家庭经营、夫妻沟通与自我成长的实用指南',
            url: 'https://diyiciderenqi.com/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://diyiciderenqi.com/' },
                { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://diyiciderenqi.com/about' },
              ],
            },
            mainEntity: {
              '@type': 'FAQPage',
              mainEntity: [
                { '@type': 'Question', name: '这个网站的内容是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，所有文章和指南内容完全免费。' } },
                { '@type': 'Question', name: '文章的作者是谁？', acceptedAnswer: { '@type': 'Answer', text: '文章由多位经历过婚姻磨合期的女性共同创作，同时也有持证心理咨询师对内容进行专业把关。' } },
                { '@type': 'Question', name: '如何订阅每周婚姻指南？', acceptedAnswer: { '@type': 'Answer', text: '在首页底部输入邮箱地址即可免费订阅。' } },
                { '@type': 'Question', name: '可以投稿分享自己的故事吗？', acceptedAnswer: { '@type': 'Answer', text: '当然可以！请通过联系表单与我们取得联系。' } },
              ],
            },
          }),
        }}
      />
    </>
  );
}